import { Modal, ModalContent } from "@heroui/react";
import { BulkShipForm } from "./bulk-ship/bulk-ship-form";

interface BulkUploadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function BulkUploadDialog({
  open,
  onOpenChange,
}: BulkUploadDialogProps) {
  return (
    <Modal
      isOpen={open}
      onOpenChange={onOpenChange}
      size="5xl"
      scrollBehavior="inside"
      classNames={{ base: "max-h-[90vh]" }}
    >
      <ModalContent>
        <BulkShipForm onClose={() => onOpenChange(false)} />
      </ModalContent>
    </Modal>
  );
}
